export const SIGN_UP_MUTATION = "signUpMutation";
export const SIGN_UP_WITH_FACEBOOK_MUTATION = "signUpWithFacebookMutation";
export const LOGIN_MUTATION = "loginMutation";
export const SAVE_TOKEN_MUTATION = "saveTokenMutation";
export const SET_USER_LOGGED_MUTATION = "setUserLoggedMutation";
export const LOGOUT_MUTATION = "logoutMutation";
export const CHANGE_LOGGED_IN_STATUS_MUTATION = "changeLoginStatusMutation";
export const CHANGE_USER_EDITED_VALUE_MUTATION = "changeEditedValueMutation";
export const REMOVE_USER_DETAILS_MUTATION = "removeUserDetailsMutation";
export const SET_REMAINING_EVENTS_COUNT_MUTATION = "setRemainingEventsCountMutation";